import React from 'react';

import { observer } from 'mobx-react';
import { Creatable } from 'react-select';

import InputTextField from './InputTextField';

@observer
class CreatableSelectField extends InputTextField {
  onBlurHandler() {
    this.touched = true;
  }

  static defaultPromptTextCreator(label) {
    return label;
  }

  static defaultIsValidNewOption() {
    return false;
  }

  get inputComponent() {
    const { allowNewOptions = true, ...props } = this.props;
    if (!allowNewOptions) {
      props.isValidNewOption = CreatableSelectField.defaultIsValidNewOption;
    }

    return (
      <Creatable
        onBlur={this.onBlurHandler}
        promptTextCreator={CreatableSelectField.defaultPromptTextCreator}
        {...props}
      />
    );
  }
}

export default CreatableSelectField;



// WEBPACK FOOTER //
// ./src/common/components/fields/CreatableSelectField.jsx